import { useState, useEffect } from "react";
import apis from '../api';

const useParamsRetefuente = () => {
    const [params, setParams] = useState([]);
    const headers = {
        authorization: localStorage.getItem('token')
    }
    let payload = {
        ENTITY: localStorage.getItem('entity'),
        CLIENT: localStorage.getItem('client'),
        OPTION: "2"
    }
    useEffect(() => {
        const template = async () => {
            let parametros = [];
            let lista = [];
            await apis.postRetefuenteReport(payload, headers).then(res => {
                parametros = res.data["PDF"]
                console.log(parametros)
            })
            if (parametros.length > 0) {
                parametros.forEach((element, index) => {
                    element["DETAIL"].forEach((row, i) => {
                        if (row.LABEL === 'p_persona') {
                            lista = row.DETAIL
                        }
                    })
                })
            }
            setParams(lista)
        }
        template()
    }, []);

    return [params];
};

export default useParamsRetefuente;